// extracted by mini-css-extract-plugin
export default {"mobileMenu":"bIgxj-","closed":"cIgxj-","maxHeight":"dIgxj-","mobileMenuHeader":"eIgxj-","mobileMenuHeaderTitle":"fIgxj-","dropdownMobileMenuOpen":"gIgxj-"};